// extracted by mini-css-extract-plugin
export default {"addToWishListButton":"addToWishListButton__0c7c74","wishListExpanded":"wishListExpanded__492b0f","wishListButtonContent":"wishListButtonContent__ef8b31"};